export const PUMB_SETTINGS = {
  IMPORT_CONFIG: 'ui:pumb_import_config',
  IMPORT_ENABLED: 'ff:pumb_import_enabled',
} as const;
